export enum SmsType {
  SENT = "sent",
  RECEIVED = "received",
}

export enum SmsSentStatus {
  PENDING = "pending",
  SENT = "sent",
  RE_SENT = "re-sent",
  NO_DELIVERED = "no-delivered",
  MESSAGE_REJECTED = "message-rejected",
  SMS_REJECTED = "sms-rejected",
}

export enum CommunicationType {
  SMS = "SMS",
  CALL = "Appel",
  EMAIL = "Email",
}

export enum CreateAction {
  NONE = 0,
  CREATE = 1,
  CREATE_AND_LINK_EMAIL = 2,
  CREATE_AND_LINK_SMS = 3,
}
